module.exports = function(posts) {
	'use strict'
	posts.directive('categoriesDir',categoriesDir);
	categoriesDir.$inject=[];
	function categoriesDir() {
		return {
			template: require('./partial/categories.html'),
			controller:'categoriesController',
			controllerAs:'vmc',
			link: function(scope, element, attrs, ctrl) {
				    
			}

		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/postsModule/categories/js/directive/categoriesDirective.js
// module id = 551
// module chunks = 0